import React from "react";
import Legal from "../components/layout/Legal";

const TermsAndCondition = () => {
  return (
    <Legal pageTitle="Terms and Conditions" variant="enterprise">
      <div className="flex flex-col gap-12">
        {/* 1 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">
            1. Acceptance of Terms
          </p>
          <p className="b2 text-grey-05">
            By accessing or using computechoice.com (the Site), you agree to be
            bound by these Terms of Use. If you do not agree to these terms,
            please do not use the Site. Continued use of the Site following any
            updates to these terms constitutes acceptance of the revised terms.
          </p>
        </div>

        {/* 2 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">
            2. About Computechoice.com
          </p>
          <p className="b2 text-grey-05">
            Computechoice.com is operated as a B2B technology marketing
            platform. The Site hosts informational and promotional campaigns on
            behalf of enterprise technology vendors and their authorised channel
            partners, including campaigns related to Hewlett Packard Enterprise
            (HPE) products and services. Content on the Site is for
            informational and promotional purposes only and does not constitute
            a binding commercial offer unless expressly stated.
          </p>
        </div>

        {/* 3 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">3. Eligibility</p>
          <p className="b2 text-grey-05">
            The Site is intended for use by business professionals and
            organisations evaluating enterprise technology solutions. By using
            the Site, you represent that you are accessing it in a professional
            or business capacity.
          </p>
        </div>

        {/* 4 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">4. Permitted Use</p>
          <p className="b2 text-grey-05 mb-2">
            You may access and use the Site for lawful purposes only. You agree
            not to:
          </p>
          <ol className="b2 text-grey-05 list-decimal ps-6 space-y-2">
            <li>
              Use the Site for any unlawful, fraudulent, or harmful purpose
            </li>
            <li>Attempt to gain unauthorised access to any part of the Site</li>
            <li>
              Interfere with or disrupt the Site’s functionality or security
            </li>
            <li>
              Scrape or collect data using automated means without permission
            </li>
            <li>Reproduce or distribute content without authorisation</li>
          </ol>
        </div>

        {/* 5 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">
            5. Intellectual Property
          </p>
          <p className="b2 text-grey-05">
            All content on the Site, including text, graphics, logos, product
            information, and technical materials, is the property of
            Computechoice.com or its clients and partners, and is protected by
            applicable intellectual property laws. HPE product names, logos, and
            trademarks are the property of Hewlett Packard Enterprise
            Development LP. Unauthorised use of any content or trademarks
            appearing on the Site may violate copyright, trademark, and other
            applicable laws.
          </p>
        </div>

        {/* 6 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">
            6. Third-Party Links
          </p>
          <p className="b2 text-grey-05">
            The Site may contain links to third-party websites including HPE.com
            and partner portals. These links are provided for informational
            convenience only. Computechoice.com does not endorse, control, or
            assume responsibility for the content, privacy practices, or
            availability of any third-party websites. Your use of third-party
            sites is subject to their respective terms and policies.
          </p>
        </div>

        {/* 7 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">7. Disclaimers</p>
          <p className="b2 text-grey-05">
            The Site and its content are provided on an as-is and as-available
            basis. Computechoice.com makes no representations or warranties of
            any kind, express or implied, regarding the accuracy, completeness,
            reliability, or suitability of the information provided. Product
            specifications, availability, and pricing are subject to change and
            should be confirmed directly with HPE or an authorised
            representative.
          </p>
        </div>

        {/* 8 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">
            8. Limitation of Liability
          </p>
          <p className="b2 text-grey-05">
            o the fullest extent permitted by applicable law, Computechoice.com
            and its operators shall not be liable for any direct, indirect,
            incidental, special, or consequential damages arising from your use
            of or inability to use the Site, or from reliance on any content
            provided on the Site.
          </p>
        </div>

        {/* 9 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">9. Modifications</p>
          <p className="b2 text-grey-05">
            Computechoice.com reserves the right to modify these Terms of Use at
            any time. Material changes will be reflected in the Last Updated
            date at the top of this page. Your continued use of the Site after
            changes are posted constitutes your acceptance of the updated terms.
          </p>
        </div>

        {/* 10 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">10. Governing Law</p>
          <p className="b2 text-grey-05">
            hese Terms of Use shall be governed by and construed in accordance
            with the laws applicable in the jurisdiction in which the operating
            entity is registered, without regard to conflict of law principles.
          </p>
        </div>

        {/* 11 */}
        <div>
          <p className="b1 text-grey-08 mb-4 font-google">11. Contact</p>
          <p className="b2 text-grey-05">
            For any questions regarding these Terms, contact us at:
          </p>
          <p className="b2 text-grey-05 mt-2 font-medium">
            legal@computechoice.com
          </p>
        </div>
      </div>
    </Legal>
  );
};

export default TermsAndCondition;
